// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb0e5866","453":"df195ce9","455":"f9e13a33","977":"486e8213"}[chunkId] + ".chunk.js";
};